import { Link } from 'react-router-dom';
import { useReportNotFound } from '../layouts/route-outcome';

export default function NotFoundPage() {
  // The breadcrumb trail is built from the URL's segments, so without this it
  // renders a plausible path above a page that does not exist (QA ledger
  // NAV-002). Only the page that actually rendered knows.
  useReportNotFound();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
    }}>
      <h1 style={{ fontSize: '6rem', marginBottom: '1rem', color: 'var(--primary)' }}>
        404
      </h1>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: 'var(--foreground)' }}>
        Page Not Found
      </h2>
      <p style={{ fontSize: '1.125rem', color: 'var(--muted-foreground)', marginBottom: '2rem' }}>
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/workspace"
        style={{
          padding: '0.75rem 2rem',
          background: 'var(--primary)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '0.5rem',
          fontWeight: 600,
        }}
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
